export default __webpack_public_path__ + "static/media/weather.3dcf04b1.png";